import ICalibrationSetAttribute = ZoneIQCalibration.ICalibrationSetAttribute;
import { AttributeModel } from '../common-models/attribute.model';

export class CalibrationSetAttribute extends AttributeModel implements ICalibrationSetAttribute {
    Id?: number;
    ParentId?: number;
    ParentType?: number;
    Description: string;
    IsEnabled?: boolean;

    constructor(data: ICalibrationSetAttribute) {
        super(
            data,
            [
                'Id',
                'ParentId',
                'ParentType',
                'AttributeType',
                'AttributeValue',
                'Description',
                'IsEnabled'
            ]
        );
    }

    static factory(data: ICalibrationSetAttribute) {
        return new CalibrationSetAttribute(data);
    }
}
